import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHead } from "@/components/common";
import { Smartphone, Zap, MessageCircle } from "lucide-react";

const FLOW = [
  "Resolve QR & show scanned brand (link preview awards nothing)",
  "Identify customer from verified WhatsApp sender",
  "Program terms + optional marketing consent",
  "Atomic claim → base + scheme points → receipt",
  "Eligible game (scratch / spin) tap-to-reveal",
  "Secure beneficiary form → UPI payout (never ask bank number in chat)",
  "Passbook, feedback, language change",
];

export default function WhatsApp() {
  const nav = useNavigate();
  return (
    <div>
      <PageHead overline="WhatsApp Inbox & Journey" title="WhatsApp Inbox" desc="One shared WhatsApp Business number across all brands. Deterministic transaction workflow with an AI language layer that can explain verified data only." />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-slate-200 p-6">
          <h3 className="font-semibold text-slate-800 mb-4 font-head flex items-center gap-2"><MessageCircle size={18} className="text-violet-600" /> Journey configuration</h3>
          <ol className="space-y-3">
            {FLOW.map((f, i) => (
              <li key={i} className="flex gap-3 text-sm">
                <span className="w-6 h-6 shrink-0 rounded-full tnp-gradient text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
                <span className="text-slate-600 pt-0.5">{f}</span>
              </li>
            ))}
          </ol>
          <div className="mt-5 text-xs text-slate-400 bg-slate-50 rounded-lg p-3">
            Main menu: My Points · Passbook · Redeem · Available Games · Give Feedback · Change Language · Help. Default English & Hindi. Opt-out respected at dispatch. Human takeover pauses automation.
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-6 flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 rounded-2xl tnp-gradient flex items-center justify-center mb-4"><Smartphone size={28} className="text-white" /></div>
          <h3 className="font-semibold text-slate-800 font-head">Live Consumer Simulator</h3>
          <p className="text-sm text-slate-500 mt-1 mb-4 max-w-xs">Run the full journey against real backend services — QR claim, scheme points, games, UPI payout and feedback.</p>
          <button data-testid="launch-simulator-btn" onClick={() => nav("/simulator")} className="flex items-center gap-2 tnp-gradient text-white font-semibold px-5 py-2.5 rounded-lg"><Zap size={16} /> Launch Simulator</button>
          <div className="mt-3 text-[11px] text-amber-600">Sandbox · provider stubs · isolated test data</div>
        </div>
      </div>
    </div>
  );
}
